import React from "react";
import { TopBar } from "./topbar";
import { Navigation } from "./navigation";
import { Footer } from "./footer";

/**
 * Shared page wrapper — renders TopBar + Navigation above and Footer below page content.
 */
export const Layout = ({ contactData, children }) => (
  <div>
    <TopBar data={contactData} />
    <Navigation />
    {children}
    <Footer data={contactData} />
  </div>
);
